<template>
    <div>
        <b-form-group
            :state="isValid"
            :invalid-feedback="invalidFeedback"
            :description="helpText"
        >
            <template v-slot:label>
                <label class="form-label" :for="fieldId">{{ fieldLabel }}: <slot></slot> </label>
            </template>
            <b-form-select
                :id="fieldId"
                :value="value"
                @input="changeValue"
                :options="options"
                text-field="display_name"
                :state="isValid"
                :disabled="disabled"
            />
        </b-form-group>
    </div>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";
    import {isNull} from "@/utils/formatting";

    export default {
        name: "SelectField",
        mixins: [fieldMixin],
        props: {
            choices: {
                type: Array,
            },
        },
        computed: {
            options() {
                let finalChoices = !isNull(this.choices) ? this.choices : this.field.choices;
                if (this.field.hasOwnProperty('required') && !this.field.required) {
                    return [{
                        "value": "",
                        "display_name": "-----"
                    }].concat(finalChoices);
                }
                return finalChoices;
            }
        },
    };
</script>

<style scoped>

</style>